import L from 'leaflet'
import {useMemo} from 'react'
import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet'
import {usePatientContext} from './StyleDetailInformationWrapper'

const geoUrl =
    'https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json'

export default function MapCurrentLocation() {
    const {currentViewedUser} = usePatientContext()
    const position = useMemo(() => {
        if (
            currentViewedUser?.lastLocationCoordinates &&
            currentViewedUser?.lastLocationCoordinates.latitude &&
            currentViewedUser?.lastLocationCoordinates.longitude
        ) {
            return [
                currentViewedUser.lastLocationCoordinates?.latitude,
                currentViewedUser.lastLocationCoordinates?.longitude,
            ]
        } else {
            return []
        }
    }, [currentViewedUser])

    const iconMarker = L.icon({
        iconUrl: require('../../../assets/icons/locationMarker.png'),
        iconSize: [40, 40],
        iconAnchor: [12, 12],
        popupAnchor: [0, 0],
    })

    // const mapContainerRef = useRef(null)
    // const [isMapHovered, setIsMapHovered] = useState(false)

    // //#region Event Listener
    // const [bindMouseEnterListener, unbindMouseEnterListener] = useEventListener(
    //     {
    //         target: mapContainerRef,
    //         type: 'mouseenter',
    //         listener: () => {
    //             setIsMapHovered(true)
    //         },
    //     },
    // )

    // const [bindMouseLeaveListener, unbindMouseLeaveListener] = useEventListener(
    //     {
    //         target: mapContainerRef,
    //         type: 'mouseleave',
    //         listener: () => {
    //             setIsMapHovered(false)
    //         },
    //     },
    // )
    // //#endregion

    // //#region Effect
    // useEffect(() => {
    //     bindMouseEnterListener()
    //     bindMouseLeaveListener()

    //     return () => {
    //         unbindMouseEnterListener()
    //         unbindMouseLeaveListener()
    //     }
    // }, [
    //     bindMouseEnterListener,
    //     bindMouseLeaveListener,
    //     unbindMouseEnterListener,
    //     unbindMouseLeaveListener,
    // ])
    // //#endregio

    return (
        <div className="relative px-4">
            {!position || position.length === 0 ? (
                <div className="text-center">No location data available</div>
            ) : (
                <div>
                    <div className="mb-3">
                        <h2 className="text-lg font-semibold mb-1">
                            <span>
                                <i className="pi pi-map-marker mr-2"></i>
                            </span>
                            Current Location
                        </h2>
                        <p className="text-base px-1">
                            View the last detected location of the user
                        </p>
                    </div>
                    <div className="mb-3">
                        <MapContainer
                            center={position}
                            zoom={13}
                            style={{
                                width: '100%',
                                height: '40vh',
                            }}
                            scrollWheelZoom={true}>
                            <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />

                            <Marker position={position} icon={iconMarker}>
                                <Popup>
                                    <span>{'Last detected location'}</span>
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>
                    <p className="text-center">
                        {currentViewedUser?.lastLocation || ''}
                    </p>
                </div>
            )}
        </div>
    )
}
